import React, { useEffect } from 'react'
import styles from './registration.module.scss'
import MainContainer from 'components/generic/MainContainer'
import OuterContainer from 'components/generic/OuterContainer'
import WelcomeUser from './walk-up/WelcomeUser'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import UserMessageFullScreen from 'components/screens/UserMessageFullScreen'
import { MessageTypes } from 'constants/message-screens'
import Storage from 'modules/storage'
import LoadingSpinnerWithContainer from 'components/generic/LoadingSpinnerWithContainer'

const Register = () => {
  const isLoggedIn = useSelector((state: AppState) => state.user.isLoggedIn)
  const isLoading = useSelector((state: AppState) => state.user.featuresConfigLoading)

  useEffect(() => {
    if (!isLoggedIn) Storage.clearRegistrationData()
  }, [isLoggedIn])

  if (isLoading) return <LoadingSpinnerWithContainer fullScreen />
  if (isLoggedIn) return <UserMessageFullScreen messageType={MessageTypes.SIGNOUT_REQUIRED} />

  return (
    <OuterContainer className={styles.registerOuter}>
      <MainContainer hasBorder={true} className={styles.register}>
        <WelcomeUser />
      </MainContainer>
    </OuterContainer>
  )
}

export default Register
